function stripHtml(html) {
    var tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
}

export const StrippedHTMLFreeRenderer = (props) => {
    return <span>{stripHtml(props.data.body)}</span>;
};
